export default function AttractionsSection() {
  return (
    <>
      {/* 働きやすさ Section */}
      <section className="py-24 bg-gradient-to-br from-cyan-50 to-blue-50 observe-animation opacity-0">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
            <div className="h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/48842a0b5e97fb2f7883b57e57ef58a8.jpg"
                alt="働きやすさ"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="space-y-8">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                働きやすさ
              </h2>
              <p className="text-2xl text-cyan-600 font-medium leading-relaxed">
                週1日出勤やWワークもOK。ライフスタイルに合わせた働き方が可能です
              </p>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  まごころヘルパーは、職員の希望を尊重したシフト調整で、私生活との両立が叶います。週1日からの出勤やWワークも可能です。また、「3週目だけ4日間働きたい」「来月は4週目の出勤を増やしたい」といった流動的なシフトの相談もOK。残業もほぼありません。一方で、「もう少しお給料を増やしたい」という気持ちがある方には、休日出勤も任せています。自分に合ったペースで仕事に打ち込める職場です。また、月1回ほどの頻度で行っている法定研修の日以外は、直行直帰ができることも働きやすさの一つ。介護記録を電子化したことで、業務後に事業所に戻って記録を書く必要もなく、効率的に働けます。
                </p>
                <p>
                  当事業所は、有休も気軽に申請が可能です。事前に申請があれば、ほぼ希望どおりに休めるよう調整します。あとから有休に切り替えることもOKなので、欠勤になった場合も気軽に取得できる環境です。また、職員同士で助け合う風土もしっかり根づいています。急に休みが必要になったときは、ほかの職員がフォローするので、心配無用です。替わりに訪問したり、スケジュールを調整したりと柔軟に対応できることが、当事業所の魅力の一つ。急な休みに対する理解がある職員ばかりなので、相談もしやすい雰囲気です。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 職場の特徴 Section */}
      <section className="py-24 bg-white observe-animation opacity-0">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
            <div className="space-y-8">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                職場の特徴
              </h2>
              <p className="text-2xl text-cyan-600 font-medium leading-relaxed">
                利用者さま一人ひとりと向き合い、温かみのある事業所を目指します！
              </p>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  まごころヘルパーは、利用者さま一人ひとりに寄り添った介護を大事にしています。「作業のような介護ではなく、一人ひとりに向き合う介護を」を方針に掲げている当事業所。「職員にとっては多くの利用者さまのなかの1人でも、利用者さまにとっての職員は、終末期に接する重要な1人」という視点を重視しています。その方に合ったケアを提供できる職場です。
                </p>
                <p>
                  当事業所は、2025年に訪問介護の事業をスタートしました。「皆で事業所を作り上げていきたい」という管理者の想いがあり、職員一人ひとり意見が言いやすい環境です。"勉強になります"と管理者が職員に対して言うことも多く、温かな雰囲気が自慢。管理者は職員の声を大切にしており、やりたいことや考えていることも気軽に話せる関係性を構築しています。
                </p>
                <p>
                  管理者が職員に定期的に話を聞きに行っていることも、当事業所の魅力の一つです。利用者さまへの介護に大変さを感じている職員がいるときは、さりげなくヒアリングして、配置にも反映。職員が少しでも気持ち良く、やりがいを持って働ける環境づくりを意識しています。
                </p>
              </div>
            </div>

            <div className="h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20Japanese%20home%20care%20worker%20leaning%20forward%20attentively%20listening%20to%20an%20elderly%20Japanese%20person%20with%20genuine%20care%20and%20empathy%20in%20a%20typical%20Japanese%20home%20interior.%20The%20caregiver%20is%20making%20eye%20contact%20showing%20deep%20personal%20connection%20and%20compassion.%20Scene%20has%20warm%20natural%20lighting.%20No%20medical%20equipment%20visible.%20Photorealistic%20style%20capturing%20authentic%20moments%20of%20compassionate%20one-on-one%20care%20and%20emotional%20support%20in%20home%20care%20setting&width=800&height=1000&seq=recruit-caring-compassion-feature&orientation=portrait"
                alt="職場の特徴"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
